import { api_configs } from "src/api-services";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getTodayemp = createAsyncThunk(
    'todayemployeelist/getTodayemp',
    async (payload) => {
        try {
            // Simulating async operation, returning dummy data after a delay
            const res = await axios({
                method: "GET",
                url: `${api_configs.emptodayList}?search=${payload || ""}`,
                headers: {
                    token: window.localStorage.getItem("token")
                }
            });
            if (res.data.responseCode === 200) {
                return res.data.result;
            }
            // await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulating delay
            // return cardDetails.data; // Return dummy data directly
        } catch (error) {
            throw error; // Let the rejection handle in createSlice catch this
        }
    }
);

// Slice for products
const todayempSlice = createSlice({
    name: 'todayemployeelist',
    initialState: { isLoading: false, todayemp: [], error: null },
    extraReducers: (builder) => {
        builder
            .addCase(getTodayemp.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getTodayemp.fulfilled, (state, action) => {
                state.isLoading = false;
                state.todayemp = action.payload;
                state.error = null;
            })
            .addCase(getTodayemp.rejected, (state, action) => {
                state.isLoading = false;
                state.todayemp = [];
                state.error = action.error.message; // Access error message
            });
    },
});



// Selectors to access state from Redux store
export const selectTodayemplist = (state) => state.todayemployeelist.todayemp;

// Exporting reducers
export default todayempSlice.reducer;